var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgProvider3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI_navigation",
    transform: "translate(-197.000000, -2217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(197.000000, 2217.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#117093",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    rx: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(18.000000, 38.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(35.977099, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0229007634,82 L0.0229007634,59.5 C0.0229007634,48.7304474 8.75334814,40 19.5229008,40 L19.5229008,40 L19.5229008,40 L26.0229008,53.7179215 L32.5229008,40 C43.2924534,40 52.0229008,48.7304474 52.0229008,59.5 L52.0229008,82 L52.0229008,82",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 26.0229008,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3163848,73.330275 L13.8806567,73.3325651 L13.8844823,67.579908 C13.8865862,64.416175 16.4507708,61.8519864 19.6145038,61.8498777 C22.772796,61.8477725 25.3348042,64.4063676 25.3369094,67.5646598 C25.336911,67.567198 25.3369111,67.5697362 25.3369094,67.5722744 L25.3330838,73.3249315 L25.3330838,73.3249315 L21.8973556,73.3272216",
    id: "Path-5",
    transform: "translate(19.610687, 67.589313) rotate(-15.000000) translate(-19.610687, -67.589313) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6564885,40.6946565 C13.6564885,48.0229008 14.8778626,55.1475827 17.3206107,62.0687023",
    id: "Path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2519084,41.3053435 C36.7947413,49.0407125 37.6089907,54.740458 38.6946565,58.4045802",
    id: "Path-6",
    transform: "translate(37.473282, 49.854962) scale(-1, 1) translate(-37.473282, -49.854962) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.9465649,
    cy: 61.1526718,
    r: 2.7480916
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 3.664122)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.1841408,
    cy: 14.5436984,
    r: 14.2078205
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67.5524225 L0,49.6057018 C-1.11268042e-15,40.5199767 7.36543549,33.1545412 16.4511606,33.1545412 L16.4511606,33.1545412 L16.4511606,33.1545412 L22.4334008,44.3712416 L27.667861,33.1545412",
    id: "Path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(86.358779, 3.664122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(19.141221, 34.000000) scale(-1, 1) translate(-19.141221, -34.000000) translate(0.641221, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.1841408,
    cy: 14.5436984,
    r: 14.2078205
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67.5524225 L0,49.6057018 C-1.11268042e-15,40.5199767 7.36543549,33.1545412 16.4511606,33.1545412 L16.4511606,33.1545412 L16.4511606,33.1545412 L22.4334008,44.3712416 L27.667861,33.1545412",
    id: "Path-11"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProvider3);
export default __webpack_public_path__ + "static/media/img-provider3.f9caa9b15f57ede8b1caf4dbc8000fa0.svg";
export { ForwardRef as ReactComponent };